import { useMutation } from '@tanstack/react-query';
import { trackVisitor, VisitorData } from '../api/visitor';

export function useVisitorTracking() {
    return useMutation({
        mutationFn: (data: VisitorData) => trackVisitor(data),
    });
}

